import React, { useState } from "react";
import { truncateText } from "../../../utils/avatarUtils";
import "./RecentActivityCard.scss";

const REASON_MAX_LEN = 35;

// Date & Time: display as-is from API (backend sends dd/MM/yyyy hh:mm tt)
const getDateTime = (row) => {
  const v = row.dateTime ?? row.DateTime ?? row.DateAndTime ?? row.formattedDateTime ?? row.FormattedDateTime ?? row.CreatedDate ?? "";
  return v != null && String(v).trim() !== "" ? String(v) : "—";
};

const DEFAULT_ACTIVITIES = [
  { id: 1, action: "Uploaded", reason: "Document uploaded for review and approval.", dateTime: "03/02/2025 10:30 AM" },
  { id: 2, action: "Updated", reason: "Version updated with latest facility temperature logs.", dateTime: "03/02/2025 09:45 AM" },
  { id: 3, action: "Approved", reason: "Section 5.2 reviewed and approved for dosage administration.", dateTime: "02/02/2025 04:15 PM" },
  { id: 4, action: "Signed", reason: "Principal investigator signature added to contact information.", dateTime: "02/02/2025 11:20 AM" },
  { id: 5, action: "Resolved", reason: "Adverse event summary comment resolved with follow-up dates.", dateTime: "01/02/2025 03:00 PM" },
  { id: 6, action: "Updated", reason: "Reference ranges verified and updated against the lab manual.", dateTime: "31/01/2025 02:30 PM" },
];

// Dashboard clone: same as ISF RecentActivityCard but without Document Title column
const RecentActivityCard = ({
  activities = DEFAULT_ACTIVITIES,
  onRowClick,
}) => {
  const [expandedId, setExpandedId] = useState(null);

  const toggleReason = (e, id) => {
    e.stopPropagation();
    setExpandedId((prev) => (prev === id ? null : id));
  };

  const list = activities === undefined ? DEFAULT_ACTIVITIES : activities;
  const hasData = list.length > 0;

  return (
    <div className="dashboard-recent-activity-card">
      <div className="dashboard-recent-activity-card__header">
        <span className="dashboard-recent-activity-card__title">Recent Activity</span>
      </div>

      {!hasData ? (
        <div className="dashboard-recent-activity-card__empty">
          No data available
        </div>
      ) : (
        <div className="dashboard-recent-activity-card__table-wrap">
          <table className="dashboard-recent-activity-card__table">
            <thead>
              <tr>
                <th className="dashboard-recent-activity-card__col-action">Activity</th>
                <th className="dashboard-recent-activity-card__col-reason">Reason</th>
                <th className="dashboard-recent-activity-card__col-datetime">Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {list.map((row) => (
                <tr
                  key={row.id}
                  className={onRowClick ? "dashboard-recent-activity-card__row--clickable" : ""}
                  onClick={onRowClick ? () => onRowClick(row) : undefined}
                >
                  <td className="dashboard-recent-activity-card__col-action">
                    <span className="dashboard-recent-activity-card__truncate" title={row.action}>
                      {row.action}
                    </span>
                  </td>
                  <td
                    className={`dashboard-recent-activity-card__col-reason dashboard-recent-activity-card__preview-cell ${expandedId === row.id ? "dashboard-recent-activity-card__preview-cell--expanded" : ""}`}
                    title={row.reason}
                  >
                    <span className="dashboard-recent-activity-card__preview">
                      {expandedId === row.id
                        ? row.reason
                        : truncateText(row.reason, REASON_MAX_LEN)}
                    </span>
                    {row.reason && row.reason.length > REASON_MAX_LEN && (
                      <button
                        type="button"
                        className="dashboard-recent-activity-card__see-more"
                        onClick={(e) => toggleReason(e, row.id)}
                      >
                        {expandedId === row.id ? "[see less]" : "[see more]"}
                      </button>
                    )}
                  </td>
                  <td className="dashboard-recent-activity-card__col-datetime">
                    <span
                      className="dashboard-recent-activity-card__truncate"
                      title={getDateTime(row)}
                    >
                      {getDateTime(row)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RecentActivityCard;
